import { authorizationHeader } from '@picsart/growth-rc/services/auth';
import IS_BROWSER from '@picsart/rc/isBrowser';
import getTimeUntil from '../getTimeUntil/index.js';
import { post, getApiUrl, patch, get } from '../httpService/index.js';
import deepCompare from '../deepCompare/index.js';

var cache = {};
var validatePromo = function validatePromo(data, accessToken) {
  if (cache.request && cache.response && deepCompare(cache.request, data)) {
    return Promise.resolve(cache.response);
  }
  cache = {
    request: data
  };

  // invalidate cache
  setTimeout(function () {
    cache = {};
  }, 3000);
  return post("".concat(getApiUrl(), "/shop/subscription/promos/validate"), data, {
    headers: authorizationHeader(accessToken)
  }).then(function (response) {
    cache.response = response;
    return response;
  });
};
var redeemPromo = function redeemPromo(data) {
  var accessToken = data.accessToken,
    promoCode = data.promoCode,
    originalOrderId = data.originalOrderId;
  return patch("".concat(getApiUrl(), "/shop/subscription/v2/promos/redeem"), {
    original_order_id: originalOrderId,
    promo_code: promoCode
  }, {
    headers: authorizationHeader(accessToken)
  });
};
var fetchSpecialOfferPromo = function fetchSpecialOfferPromo() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    pathName = _ref.pathName,
    touchpoint = _ref.touchpoint,
    allowTrial = _ref.allowTrial;
  var accessToken = arguments.length > 1 ? arguments[1] : undefined;
  var path = pathName || (IS_BROWSER ? window.location.pathname : '');
  var host = IS_BROWSER ? window.location.hostname : '';
  var searchParams = new URLSearchParams();
  searchParams.set('requestPath', encodeURIComponent(path));
  searchParams.set('requestHostname', encodeURIComponent(host));
  touchpoint && searchParams.set('touchpoint', touchpoint);
  allowTrial && searchParams.set('allowTrial', 'true');
  var url = "".concat(getApiUrl(), "/shop/subscription/promo/special-offer?").concat(searchParams.toString());
  return get(url, {
    headers: authorizationHeader(accessToken)
  });
};
var getBannerType = function getBannerType(_ref2) {
  var _offerPromo$special_o, _offerPromo$special_o2, _offerPromo$special_o3;
  var lastRenewalPaymentStatus = _ref2.lastRenewalPaymentStatus,
    offerPromo = _ref2.offerPromo,
    expire_date = _ref2.expire_date;
  if ((offerPromo === null || offerPromo === void 0 || (_offerPromo$special_o = offerPromo.special_offer_data) === null || _offerPromo$special_o === void 0 ? void 0 : _offerPromo$special_o.name) === 'valentine') return 'pink';
  if ((offerPromo === null || offerPromo === void 0 || (_offerPromo$special_o2 = offerPromo.special_offer_data) === null || _offerPromo$special_o2 === void 0 ? void 0 : _offerPromo$special_o2.name) === 'duolingo') return 'green';
  var timeUntil = getTimeUntil(expire_date);
  if (!expire_date || (offerPromo === null || offerPromo === void 0 || (_offerPromo$special_o3 = offerPromo.special_offer_data) === null || _offerPromo$special_o3 === void 0 ? void 0 : _offerPromo$special_o3.name) !== 'Winback50' || !timeUntil) return 'purple';
  if (lastRenewalPaymentStatus === 'PAID') return 'purple';
  var days = parseInt((timeUntil === null || timeUntil === void 0 ? void 0 : timeUntil.days) || '0', 10);
  if (days < 1) return 'yellow';
  if (days < 5 || days >= 30) return 'purple';
  return 'light';
};
var promoService = {
  fetchSpecialOfferPromo: fetchSpecialOfferPromo,
  getBannerType: getBannerType,
  validatePromo: validatePromo,
  redeemPromo: redeemPromo
};

export { promoService as default, fetchSpecialOfferPromo, getBannerType, redeemPromo, validatePromo };
//# sourceMappingURL=index.js.map
